const ServicesPage = () => import(/* webpackChunkName: "services-page" */ '@/views/services/ServicesPage')
const OneServicePage = () => import(/* webpackChunkName: "services-page" */ '@/views/services/OneServicePage')

export default [{
  path: 'services',
  name: 'services',
  component: ServicesPage
}, {
  path: 'services/:id/:childId?/:widgetId?',
  name: 'service',
  component: OneServicePage
}]
